import React from "react";
import Grid from "@material-ui/core/Grid";

const GridTable = (props) => {
  return (
    <>
      {props.tableContent.map((row, index) => (
        <Grid item key={index}>
          <Grid container direction="row" spacing={props.spacing}>
            <Grid style={{ fontWeight: "bold" }} xs={props.keySize} item>
              {row.key}
            </Grid>
            <Grid xs={props.valueSize} item>
              {row.value}
            </Grid>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default GridTable;
